module.exports = __webpack_public_path__ + "img/Proliferation-PDAC_GSE111672.7493f1d7.png";